import React from 'react'
import { SquigglyArrowWrapper } from './SguigglyArrow.styles'

interface ArrowProps {
    color?: string
    strokeWidth?: number
}

const Arrow: React.FC<ArrowProps> = ({
    color = 'black',
    strokeWidth = 2,
}): JSX.Element => {
    return (
        <SquigglyArrowWrapper>
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <pattern
                        id="single-wave-pattern"
                        x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        patternUnits="objectBoundingBox"
                        viewBox="0 0 100 50"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M0,25 Q25,0 50,25 T100,25"
                            fill="none"
                            stroke={color}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </pattern>
                </defs>

                <rect
                    x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="url(#single-wave-pattern)"
                />
            </svg>
        </SquigglyArrowWrapper>
    )
}

export default Arrow
